import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import PropTypes from 'prop-types';
import React from 'react';
import { FormHelperText } from 'components/form-fields';
import 'components/form-fields/FormFields.css';

export function FormReadonly(
    {
        headingText = '',
        value = '',
        loading = false,
        largerValueText = false,
        bold = false,
        helperText = null,
        className
    }
) {
    return (
        <div className="form-field">
            <ShowHide
                evaluator={headingText.length > 0}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading, "bold": bold }, className)}>{headingText}</h4>

                )}
            >
            </ShowHide>
            <span className={classNames({ "form-field-readonly-value": !largerValueText, "bp6-skeleton": loading }, className)}>{value}</span>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
        </div>
    );

}

FormReadonly.propTypes = {
    headingText: PropTypes.string,
    value: PropTypes.string,
    loading: PropTypes.bool,
    largerValueText: PropTypes.bool,
    className: PropTypes.string,
    bold: PropTypes.bool,
    helperText: PropTypes.node
};